module.exports = __webpack_public_path__ + "img/fornecedor-branco.0cab7615.png";